import { action, observable, makeAutoObservable } from 'mobx';

class MutedSpeechDetectionStore {
    @observable public isUserSpeakWhileMuted: boolean = false;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public setIsUserSpeakWhileMuted = (value: boolean) => {
        this.isUserSpeakWhileMuted = value;
    };
}

export const mutedSpeechDetectionStore = new MutedSpeechDetectionStore();
